import React from 'react';
import UserMenu from './UserMenu';
import userStore from '../store/userStore';

function Header() {
  const { sidebarOpen, setSidebarOpen } = userStore();

  return (
    <header className='sticky top-0 bg-white border-b border-gray-200 z-30'>
      <div className='px-4 sm:px-6 lg:px-8'>
        <div className='flex items-center justify-between h-16'>
          {/* Header: Left side */}
          <div className='flex items-center'>
            {/* Hamburger button */}
            <button
              className='text-gray-500 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg p-1.5 lg:hidden transition-colors duration-150'
              aria-controls='sidebar'
              aria-expanded={sidebarOpen}
              onClick={e => {
                e.stopPropagation();
                setSidebarOpen(!sidebarOpen);
              }}
            >
              <span className='sr-only'>Open sidebar</span>
              <svg className='w-6 h-6 fill-current' viewBox='0 0 24 24'>
                <path className='text-gray-500' d='M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z' />
              </svg>
            </button>
          </div>

          {/* Header: Right side */}
          <div className='flex items-center'>
            {/* User Menu */}
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
